import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-523e1d1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contractid" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white px-6 py-4 border flex flex-col justify-center items-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка договора...", -1))
const _hoisted_4 = { class: "flex items-center justify-between mb-7" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-download" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "px-6 py-4 bg-white border text-center text-sm text-gray-400 mt-6"
}
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_contract_form = _resolveComponent("contract-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_loader, { class: "mt-1 primary" })
        ]))
      : (_ctx.state.is_edit_contract)
        ? (_openBlock(), _createBlock(_component_contract_form, {
            key: 1,
            "is-create": false,
            "contract-id": _ctx.contractId,
            contract: _ctx.state.contract,
            onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.is_edit_contract = false)),
            onAdded: _ctx.onContractEdited
          }, null, 8, ["contract-id", "contract", "onAdded"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_page_title, {
                  title: `Контракт ${_ctx.state.contract.original_name || ''}`
                }, null, 8, ["title"]),
                _createVNode(_component_cheap, {
                  class: _normalizeClass(["small ml-6", {
                            green: _ctx.state.contract.status === 'active',
                            yellow: _ctx.state.contract.status === 'expiring',
                            red: _ctx.state.contract.status === 'expired',
                        }])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.state.contract.status), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.havePermissions(['contract-contract-delete']))
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 0,
                      class: "red small mr-2",
                      disabled: _ctx.state.is_loading,
                      onClick: _ctx.deleteContract,
                      hint: "Удалить договор"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_the_button, {
                  class: "primary small mr-2",
                  loading: _ctx.state.is_loading,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.is_edit_contract = true)),
                  hint: "Редактировать"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_the_button, {
                  class: "primary small mr-2",
                  loading: _ctx.state.is_contract_download_loading,
                  onClick: _ctx.downloadContract,
                  hint: "Скачать"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"]),
                _createVNode(_component_the_button, {
                  class: "primary small mr-2",
                  loading: _ctx.state.is_contract_show_loading,
                  onClick: _ctx.showContract,
                  hint: "Просмотреть"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"]),
                _createVNode(_component_the_button, {
                  class: "second text small",
                  onClick: _ctx.goBack
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createTextVNode(" Назад ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createVNode(_component_table_scroll_wrapper, {
              loading: _ctx.state.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.state.is_loading,
                  columns: _ctx.ContractsItemColumns,
                  rows: [_ctx.state.contract]
                }, {
                  td: _withCtx(({ column, row }) => [
                    (column.key === 'prolongation')
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(_ctx.getCheckOrTimesIcon(Boolean(row.is_auto_renewal)))
                        }, null, 2))
                      : _createCommentVNode("", true),
                    (column.key === 'date')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.date)), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.key === 'expiration_date')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.expiration_date)), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.key === 'createdAt')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.createdAt)), 1)
                        ], 64))
                      : (column.key === 'services')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createTextVNode(_toDisplayString(_ctx.getServicesStr(row.services)), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                          ], 64))
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows"])
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_page_title, {
              class: "mt-6",
              title: "Дополнительные документы"
            }),
            (_ctx.state.contract && _ctx.state.contract.documents.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Нет дополнительных документов "))
              : (_ctx.state.contract && _ctx.state.contract.documents.length > 0)
                ? (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                    key: 1,
                    loading: _ctx.state.is_loading
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_the_table, {
                        loading: _ctx.state.is_loading,
                        columns: _ctx.ContractsDocumentsColumns,
                        rows: _ctx.state.contract.documents
                      }, {
                        td: _withCtx(({ row, column }) => [
                          (column.key === 'number')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(row.number || '-'), 1)
                              ], 64))
                            : (column.key === 'type')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(row.type || '-'), 1)
                                ], 64))
                              : (column.key === 'date')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.date) || '-'), 1)
                                  ], 64))
                                : (column.key === 'expirationDate')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.expirationDate) || '-'), 1)
                                    ], 64))
                                  : (column.key === 'createdAt')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.createdAt) || '-'), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                                      ], 64))
                        ]),
                        actions: _withCtx(({ row }) => [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_the_button, {
                              class: "small primary mr-2",
                              hint: "Скачать",
                              onClick: ($event: any) => (_ctx.downloadDocument(row)),
                              loading: _ctx.state.is_document_loading
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 2
                            }, 1032, ["onClick", "loading"]),
                            _createVNode(_component_the_button, {
                              class: "small primary",
                              hint: "Посмотреть",
                              onClick: ($event: any) => (_ctx.showDocument(row)),
                              loading: _ctx.state.is_document_loading
                            }, {
                              default: _withCtx(() => [
                                _hoisted_15
                              ]),
                              _: 2
                            }, 1032, ["onClick", "loading"]),
                            (_ctx.havePermissions(['contract-contract-delete']))
                              ? (_openBlock(), _createBlock(_component_the_button, {
                                  key: 0,
                                  class: "red small ml-2",
                                  loading: _ctx.state.is_delete_loading,
                                  onClick: ($event: any) => (_ctx.deleteAdditionalContract(row.id)),
                                  hint: "Удалить доп. договор"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_16
                                  ]),
                                  _: 2
                                }, 1032, ["loading", "onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["loading", "columns", "rows"])
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true)
          ], 64))
  ]))
}